const PIXI = require('pixi.js');
const SVGWatermark = require('./SVGWatermark');
const PIXIWatermark = require('./PIXIWatermark');
PIXIWatermark
SVGWatermark
PIXI

module.exports = el => {
    return PIXI.utils.isWebGLSupported() && el.dataset && el.dataset.wmImage && el.dataset.wmImage !== 'false' ? PIXIWatermark(el) : SVGWatermark(el);
};



// WEBPACK FOOTER //
// ./js/viscom/boss/soccers/components/Watermark.js